"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.createAmplitudeSubscriber = void 0;
var _amplitude = _interopRequireDefault(require("./amplitude"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var createAmplitudeSubscriber = exports.createAmplitudeSubscriber = function createAmplitudeSubscriber(initialMetricsTrackerConfig) {
  var smAmplitude = null;

  // pre-initialize the amplitude object if we were initialized with a config
  if (initialMetricsTrackerConfig) {
    smAmplitude = new _amplitude.default(initialMetricsTrackerConfig);
  }
  return function (digitalDataEvent, metricsTrackerConfig) {
    // Initialize (if needed) and then track for regular, non anonymous users
    if (!smAmplitude) {
      smAmplitude = new _amplitude.default(metricsTrackerConfig);
    }
    smAmplitude.track(digitalDataEvent);
  };
};
var AmplitudeSubscriberSingleton = function () {
  return createAmplitudeSubscriber();
}();
var _default = exports.default = AmplitudeSubscriberSingleton;
//# sourceMappingURL=AmplitudeSubscriber.js.map